import { render } from "./HorizontalCardLoader.vue?vue&type=template&id=6d4d24ce"
import script from "./HorizontalCardLoader.vue?vue&type=script&lang=js"
export * from "./HorizontalCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__